import React from 'react'
import TableReclamation from '../../Components/table/TableReclamation'

const Reclamation = () => {
  return <TableReclamation />
}

export default Reclamation
